// extracted by mini-css-extract-plugin
export var closeButton = "_nc-2";
export var closeButtonIcon = "_nc-3";
export var lightboxContent = "_nc-1";
export var lightboxOverlay = "_nc-0";